import { useEffect, type ReactNode } from 'react'

import { useToast } from '@/src/general/components/ToastContext'
import { filterSearchParams } from '@/src/general/utils/filterSearchParams'
import { isMessageKey } from '@/src/lang/isMessageKey'
import { htmlTagsMap, useTranslate } from '@/src/lang/useTranslate'

export const CommunityMessage = ({ searchParams }: TSearchParamsParam): ReactNode => {
  const { message, publicationName } = filterSearchParams(searchParams)
  const { t } = useTranslate()
  const { addToast } = useToast()

  useEffect(() => {
    if (!message) return

    if (message && isMessageKey(message) && publicationName) {
      addToast({
        message: t(message, { publicationName, ...htmlTagsMap }),
      })
    } else {
      addToast({
        message: t('error.403.title'),
      })
    }
  }, [message, publicationName, addToast, t])

  return null
}
